import { render } from "./FavoriteTraining.vue?vue&type=template&id=58a0c355&scoped=true&ts=true"
import script from "./FavoriteTraining.vue?vue&type=script&lang=ts"
export * from "./FavoriteTraining.vue?vue&type=script&lang=ts"

import "./FavoriteTraining.vue?vue&type=style&index=0&id=58a0c355&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a0c355"]])

export default __exports__